import { Stack, Typography } from "@mui/material";
import { MessageInput, useChannelStateContext } from "stream-chat-react";
import { MESSAGE_COMPOSER_MAX_ROWS } from "Components/Chat/chatConstants";
import { Resources, useResource } from "Translations/Resources";

/**
 * The message composer, or a closed-conversation notice when the channel is frozen (ADR-0008).
 *
 * stream-chat-react has no frozen-channel handling of its own, so without this the composer stays
 * fully live on a frozen channel and every send fails at the API — which reads as broken software
 * rather than a closed conversation.
 *
 * The copy is deliberately REASON-FREE. A frozen channel must never explain itself: the blocked
 * party is not told they were blocked, and the same notice is intended to cover a counterpart who
 * deleted their account once that path freezes too.
 *
 * Caveat: the notice appears on the next render of this channel, not the instant a freeze lands
 * mid-session — the SDK mutates `channel.data` in place, so nothing re-renders on `channel.updated`.
 * A send attempted in that window fails at the API, which is the same end state.
 */
export const ChatComposer = () => {
  const { channel } = useChannelStateContext();
  const { t } = useResource();

  if (channel.data?.frozen === true) {
    return (
      <Stack py={3} px={2} alignItems="center">
        <Typography variant="body2" color="text.secondary" textAlign="center">
          {t(Resources.Chat.ClosedConversation)}
        </Typography>
      </Stack>
    );
  }

  return (
    <MessageInput audioRecordingEnabled maxRows={MESSAGE_COMPOSER_MAX_ROWS} />
  );
};
